import { PaxCheckPaxSession, PaxCheckRequiredAction } from "api";
import Checklist from "../checklist/checklist";
import Pax from "../pax";

export type PaxSessionId = string;

interface PaxSession {
  paxSessionId: PaxSessionId;
  pax: Pax;
  requiredAction?: PaxCheckRequiredAction;
  consented?: boolean | null;
  checklist: Checklist;
  isTravelDocumentVerified: boolean;
}

export function PaxSessionFromApi(res: PaxCheckPaxSession): PaxSession {
  const pax: Pax = {
    firstName: res.pax.firstName,
    surname: res.pax.lastName,
    birthdate: res.pax.birthdate,
  };

  return {
    paxSessionId: res.paxSessionId,
    pax: pax,
    requiredAction: res.requiredAction,
    consented: res.consented,
    checklist: Checklist.fromApi(res.checklist),
    isTravelDocumentVerified: res.isTravelDocumentVerified,
  };
}

export default PaxSession;
